import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 18"
      className="design-iconfont"
    >
      <path d="M11.2 12.6c0 .495-.36.9-.8.9-.44 0-.8-.405-.8-.9V9c0-.495.36-.9.8-.9.44 0 .8.405.8.9v3.6ZM6.4 2.095c0-.14.171-.295.4-.295h2.4c.229 0 .4.156.4.295V3.6H6.4V2.095Zm0 10.505c0 .495-.36.9-.8.9-.44 0-.8-.405-.8-.9V9c0-.495.36-.9.8-.9.44 0 .8.405.8.9v3.6Zm8.8-9h-4V2.095C11.2.94 10.303 0 9.2 0H6.8c-1.103 0-2 .94-2 2.095V3.6h-4c-.44 0-.8.405-.8.9s.36.9.8.9h.8v9.9C1.6 16.789 2.677 18 4 18h8c1.323 0 2.4-1.211 2.4-2.7V5.4h.8c.44 0 .8-.405.8-.9s-.36-.9-.8-.9Z" />
    </svg>
  )
}
const DeleteIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}
// 默认参数
DeleteIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
DeleteIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}
export default DeleteIcon
